import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import aa from "../managers/braze-instance.js";
import BrazeSdkMetadata from "./braze-sdk-metadata.js";
import { isArray as D, validateValueIsFromEnum as ta } from "../util/code-utils.js";
import { logger as E } from "../../shared-lib/index.js";
export function addSdkMetadata(a) {
  if (!aa.rr()) return;
  var t = aa.m();
  if (t) {
    if (!D(a)) return E.error("Cannot set SDK metadata because metadata is not an array."), !1;
    var _iterator = _createForOfIteratorHelper(a),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;
        if (!ta(BrazeSdkMetadata, _t, "sdkMetadata contained an invalid value.", "BrazeSdkMetadata")) return !1;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return t.addSdkMetadata(a), !0;
  }
}